import React, { useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { ELECTRICITY_POINT_TYPES } from '../../dataModels/decorators';
import { updateElectricityPoint } from 'dataModels/room';

export function ElectricityEditing({ room, electricityPoint, onClose, onSave, onChange }) {


  const updateElectricityPointWithChange = (change) => {
    const updatedElectricityPoint = { ...electricityPoint, ...change };
    const updatedRoom = updateElectricityPoint(room, updatedElectricityPoint);
    onChange(updatedRoom, 'electricityPoint', updatedElectricityPoint);
  };

  const handleSave = () => {
    const updatedRoom = updateElectricityPoint(room, electricityPoint);
    onSave(updatedRoom);
  };

  const handleDelete = () => {
    // TODO: remove electricity point
    onClose();
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">עריכת נקודת חשמל</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <Stack spacing={3} sx={{ mt: 3 }}>
        {/* Type */}
        <FormControl fullWidth>
          <InputLabel>סוג נקודת חשמל</InputLabel>
          <Select
            value={electricityPoint.type}
            onChange={(e) => updateElectricityPointWithChange( {type: e.target.value})}
            label="סוג נקודת חשמל"
          >
            {ELECTRICITY_POINT_TYPES.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Height */}
        <TextField
          label="גובה (מטרים)"
          type="number"
          value={electricityPoint.height}
          onChange={(e) => {
            const v = e.target.value;

            // allow empty while typing
            if (v === '') {
              updateElectricityPointWithChange( {height: ''});
              return;
            }

            updateElectricityPointWithChange( {height: v});
          }}
          onBlur={() => {
            const num = parseFloat(electricityPoint.height);
            if (isNaN(num)) {
              updateElectricityPointWithChange( {height: 0.2});
              return;
            }
            updateElectricityPointWithChange( {height: Math.max(0, Math.min(3, num))});
          }}
          inputProps={{ min: 0, max: 3, step: 0.1 }}
          helperText="גובה בין 0 ל-3 מטרים"
          fullWidth
        />

        {/* Actions */}
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={handleDelete}
          >
            מחק
          </Button>

          <Box sx={{ flex: 1 }} />

          <Button onClick={onClose}>ביטול</Button>
          <Button variant="contained" onClick={handleSave}>
            שמור
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}